import globalUtils from './globalUtils';

const text = value => String(value ?? '').trim();
const join = (values, separator = ' · ') => values.map(text).filter(Boolean).join(separator);

// Only Empresa fields belong here; banking and payer data are separate contracts.
export function companyIdentity(empresa = {}) {
  const fantasy = text(empresa.nome_fantasia);
  const legal = text(empresa.razao_social);
  const primaryName = fantasy || legal;
  const cnpj = text(empresa.cnpj);
  const cep = globalUtils.formatarCEP(empresa.cep);
  return {
    primaryName,
    legalName: legal && legal.toLocaleLowerCase('pt-BR') !== primaryName.toLocaleLowerCase('pt-BR') ? legal : '',
    beneficiaryName: legal || fantasy,
    cnpj: globalUtils.formatarDocumento(cnpj),
    addressLines: [
      join([join([empresa.endereco, empresa.numero], ', '), empresa.complemento, empresa.bairro]),
      join([join([empresa.municipio_nome, empresa.estado_sigla], '/'), cep])
    ].filter(Boolean),
    contacts: [...new Set([empresa.telefone1, empresa.telefone2, empresa.email, empresa.site].map(text).filter(Boolean))],
    hasLogo: Number(empresa.logo_bytes) > 0
  };
}
